"use client";

import type { ReportMeasure } from "@gettactic/api";
import React from "react";
import { useAnimatedNumber } from "../hooks/useAnimatedNumber";
import { formatValue } from "../lib/formatValue";

interface AnimatedValueProps {
  measure: Pick<ReportMeasure, "kind">;
  value: number;
  className?: string;
}

/** A measure value that counts up to where it is. */
export const AnimatedValue: React.FC<AnimatedValueProps> = ({
  measure,
  value,
  className
}) => {
  const shown = useAnimatedNumber(value);
  return <span className={className}>{formatValue(measure, shown)}</span>;
};
